import { H2 } from "@datapay-by-datacom/design-system";
import { UserManagementNavTabs, UserGroupTable } from "../components";

export function UserGroupsScreen() {
  return (
    <div>
      <H2>User Management</H2>
      <UserManagementNavTabs />
      <UserGroupTable />
    </div>
  );
}
